import axios from "axios";

const URL = "https://api-aumentosprogresivos-production.up.railway.app/"

export const axiosInstance = axios.create({
    baseURL: URL
})
